import React, {
  memo,
  useRef,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Container, Sprite } from "@pixi/react";
import * as PIXI from "pixi.js";
import WinBoxController from "./WinBoxController";
import { safeInit } from "../../../utilities";
import { Settings } from "../../../settings";

const WinBoxContainer = memo(
  forwardRef(({ symbolWidth, symbolHeight, reelSpacing }, ref) => {
    const containerRef = useRef(null);
    const controllerRef = useRef(null);

    // Initialize controller after container is ready
    useEffect(() => {
      if (!containerRef.current || controllerRef.current) return;

      safeInit(() => {
        controllerRef.current = new WinBoxController(
          containerRef.current,
          symbolWidth,
          symbolHeight,
          reelSpacing,
        );
      });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Handle resize
    useEffect(() => {
      if (controllerRef.current?.isReady()) {
        controllerRef.current.updateDimensionsAndRescale(
          symbolWidth,
          symbolHeight,
          reelSpacing,
        );
      }
    }, [symbolHeight, symbolWidth, reelSpacing]);

    // Expose controller methods
    useImperativeHandle(ref, () => ({
      getWinBoxController: () => controllerRef.current,
      showWinBoxes: (positions, targetLoops, windowMs) =>
        controllerRef.current?.showWinBoxes(positions, targetLoops, windowMs),
      showAllWinBoxes: (allLinePositions, targetLoops, windowMs) =>
        controllerRef.current?.showAllWinBoxes(allLinePositions, targetLoops, windowMs),
      hideWinBoxes: () => controllerRef.current?.hideWinBoxes(),
    }));

    return (
      <Container ref={containerRef} name="win_box_overlay" zIndex={3}>
        <Sprite
          texture={PIXI.Texture.EMPTY}
          width={symbolWidth * Settings.REEL_COUNT}
          height={symbolHeight * Settings.SYMBOLS_VISIBLE}
          anchor={0.5}
          name="win_box_overlay_placeholder"
        />
      </Container>
    );
  }),
);

export default WinBoxContainer;
